/* RF ULTRA CONFIGURATOR v3.8 — STABLE + DESKTOP FORCE + PETS (CAT/DOG) + AJAX FALLBACK
 * Changelog v3.8:
 * - Huisdieren sectie uitgebreid: Keuze uit 0, 1 of 2 Honden én 0, 1 of 2 Poezen.
 * - Elke hond heeft eigen oren-type en kleur keuze.
 * - Elke poes heeft eigen kleur keuze.
 * - Prijs telt elk huisdier individueel mee.
 * - Alle overige logica, validatie en winkelwagen-sync ongewijzigd.
 */

(() => {
  if (window.RF_DISABLE === true) return;
  console.log("RF Configurator v3.8: Script wordt geladen...");

  const RF_VERSION = "3.8.0";

  (() => {
    const id = "rf-poppins-font";
    if (document.getElementById(id)) return;
    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap";
    document.head.appendChild(link);
  })();

  function decodeHtmlEntities(str) {
    if (!str || typeof str !== "string") return str;
    return str.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, "&");
  }

  function parseJsonAttr(attr, fallback) {
    try {
      if (!attr) return fallback;
      return JSON.parse(decodeHtmlEntities(attr));
    } catch (e) {
      console.warn("RF Config: JSON parse error", e);
      return fallback;
    }
  }

  class RFUltraConfigurator {
    constructor(mountEl) {
      this.el = mountEl;

      const prevV = this.el.__rfUltraMountedVersion;
      if (this.el.__rfUltraMounted && prevV === RF_VERSION) return;
      this.el.__rfUltraMounted = true;
      this.el.__rfUltraMountedVersion = RF_VERSION;

      this.base = Number(mountEl.dataset.base || 20);
      this.extra = Number(mountEl.dataset.extra || 2);
      this.variants = parseJsonAttr(mountEl.dataset.variants, {});
      
      this.colors = parseJsonAttr(mountEl.dataset.colors, [
        { label: "Wit", hex: "#F6F7F9" },
        { label: "Zand", hex: "#D8C7A8" },
        { label: "Taupe", hex: "#9C8875" },
        { label: "Bruin", hex: "#5D4037" },
        { label: "Antraciet", hex: "#2E3238" },
        { label: "Khaki", hex: "#BDB76B" },
        { label: "Marine blauw", hex: "#000080" },
        { label: "Latte bruin", hex: "#D2B48C" },
        { label: "Desert tan", hex: "#ECD589" }
      ]);

      this.deliveryText = mountEl.dataset.deliveryText || "Verzending: 3–5 werkdagen";

      this.state = {
        mode: null,
        pop1: null, pop1Color: null,
        pop2: null, pop2Color: null,
        kids: null, kidsColor: null,
        // Huisdieren: aantal per soort + per-dier opties
        dogCount: 0,
        dog1Ears: null, dog1Color: null,
        dog2Ears: null, dog2Color: null,
        catCount: 0,
        cat1Color: null,
        cat2Color: null,
        twin: false, twinPair: "",
        star: false, starChild: "",
      };

      this.injectCSS();
      this.render();
      this.cache();
      this.bind();
      this.findFormRetry();
      this.update({ silent: true });
    }

    injectCSS() {
      if (document.getElementById("rf-ultra-v38-css")) return;
      
      const css = `
        :root {
          --rf-font: "Poppins", sans-serif;
          --rf-gold: #B48A2C;
          --rf-gold-light: #F9F5EB;
          --rf-gold-dark: #8C6A1E;
          --rf-ink: #1C1917;
          --rf-gray: #F5F5F4;
          --rf-border: #E7E5E4;
          --rf-green: #059669;
          --rf-shadow: 0 10px 30px -10px rgba(0,0,0,0.08);
          --rf-radius: 12px;
        }

        [data-rf-configurator] * { box-sizing: border-box; }
        
        [data-rf-configurator] {
          font-family: var(--rf-font) !important;
          color: var(--rf-ink);
          width: 100% !important;
          max-width: 550px !important;
          margin: 0 auto !important;
          display: block !important;
        }

        @media (min-width: 768px) {
           [data-rf-configurator] {
              max-width: 850px !important;
           }
        }

        .rfW {
          background: #fff; border: 1px solid var(--rf-border);
          border-radius: var(--rf-radius); padding: 24px; 
          box-shadow: var(--rf-shadow);
        }
        @media(max-width: 480px) { .rfW { padding: 16px; border: none; box-shadow: none; } }

        .rfH1 { font-size: 22px; font-weight: 700; margin: 0 0 8px; letter-spacing: -0.5px; line-height: 1.2; }
        .rfLead { font-size: 14px; color: #57534E; margin: 0 0 20px; line-height: 1.5; }
        .rfLabel { font-size: 13px; font-weight: 700; margin: 0 0 8px; display: block; color: var(--rf-ink); text-transform: uppercase; letter-spacing: 0.5px; }
        .rfNote { font-size: 12px; color: #78716C; margin-top: 5px; line-height: 1.3; }

        .rfBadges { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 24px; }
        .rfBadge { 
          font-size: 11px; font-weight: 600; padding: 5px 10px; border-radius: 6px;
          background: var(--rf-gray); color: #44403C; display: flex; align-items: center; gap: 5px;
        }
        .rfBadge i { color: var(--rf-gold); }

        .rfCard {
          background: #fff; border: 1px solid var(--rf-border);
          border-radius: 10px; padding: 16px; margin-bottom: 16px;
          transition: all 0.2s ease;
        }
        .rfHide { display: none !important; }

        .rfRow { display: flex; flex-wrap: wrap; gap: 10px; }
        .rfChip {
          appearance: none; border: 1px solid var(--rf-border); background: #fff;
          border-radius: 8px; padding: 12px 16px; font-size: 14px; font-weight: 600;
          color: var(--rf-ink); cursor: pointer; transition: all 0.2s;
          flex: 1; text-align: center; min-width: 80px; display: flex; align-items: center; justify-content: center; gap: 6px;
        }
        .rfChip:hover { border-color: var(--rf-gold); background: #FFFCF5; }
        .rfChip[data-active="true"] {
          border-color: var(--rf-gold); background: var(--rf-gold-light); color: var(--rf-gold-dark);
          box-shadow: 0 0 0 1px var(--rf-gold) inset; font-weight: 700;
        }
        .rfChip, .rfChip * { -webkit-text-fill-color: currentColor !important; }

        .rfColors { 
          display: grid; 
          grid-template-columns: repeat(auto-fill, minmax(110px, 1fr)); 
          gap: 10px; margin-top: 10px; 
        }
        .rfColorBtn {
          appearance: none; border: 1px solid var(--rf-border); background: #fff;
          border-radius: 8px; padding: 10px; cursor: pointer;
          display: flex; align-items: center; gap: 10px; transition: all 0.2s;
          width: 100%; justify-content: flex-start;
        }
        .rfColorBtn:hover { transform: translateY(-1px); border-color: #D6D3D1; }
        .rfColorBtn[data-active="true"] { 
          border-color: var(--rf-gold); background: var(--rf-gold-light); 
          box-shadow: 0 0 0 1px var(--rf-gold) inset;
        }
        .rfDot { width: 20px; height: 20px; border-radius: 50%; border: 1px solid rgba(0,0,0,0.1); flex-shrink: 0; }
        .rfColorLabel { font-size: 13px; font-weight: 600; color: #44403C; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

        .rfSelect {
          width: 100%; padding: 12px; border-radius: 8px; 
          border: 1px solid #E7E5E4; background-color: #fff;
          font-family: var(--rf-font); font-size: 14px; font-weight: 500;
          color: #1C1917 !important;
          appearance: none;
          background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
          background-repeat: no-repeat; background-position: right 12px center; background-size: 16px;
        }
        .rfSelect option { color: #000 !important; background: #fff !important; }

        .rfPetSubBlock {
          border-top: 1px solid var(--rf-border);
          padding-top: 14px;
          margin-top: 14px;
        }
        .rfPetSubTitle {
          font-size: 13px; font-weight: 700; color: var(--rf-ink);
          margin-bottom: 10px; display: flex; align-items: center; gap: 6px;
        }

        .rfSticky {
          position: sticky; bottom: 10px; z-index: 9999;
          background: rgba(255,255,255,0.95); backdrop-filter: blur(8px);
          border: 1px solid var(--rf-gold); border-radius: 14px;
          padding: 14px 20px; box-shadow: 0 10px 30px -5px rgba(0,0,0,0.15);
          margin-top: 24px;
        }
        .rfStickyInner { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
        .rfPriceBlock { display: flex; flex-direction: column; }
        .rfLabelSmall { font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px; color: #78716C; font-weight: 700; }
        .rfTotal { font-size: 22px; font-weight: 800; color: var(--rf-ink); line-height: 1; }
        
        .rfCTA {
          appearance: none; border: none; background: var(--rf-ink); color: #fff;
          font-weight: 700; font-size: 15px; padding: 12px 24px; border-radius: 100px;
          cursor: pointer; transition: all 0.3s; flex-grow: 1; 
          box-shadow: 0 4px 10px rgba(0,0,0,0.15);
        }
        .rfCTA:disabled { background: #E7E5E4; color: #A8A29E; cursor: not-allowed; box-shadow: none; }
        .rfCTA:not(:disabled):hover { transform: translateY(-1px); background: #000; }
        
        .rfW.ready .rfCTA { background: var(--rf-gold); color: #fff; box-shadow: 0 4px 15px rgba(180, 138, 44, 0.3); }
        .rfW.ready .rfSticky { border-color: var(--rf-green); }
        .rfW.ready .rfTotal { color: var(--rf-green); }

        .rfError { 
          background: #FEF2F2; border: 1px solid #FECACA; color: #991B1B; 
          padding: 10px; border-radius: 8px; font-size: 13px; margin-top: 12px; display: none; 
          font-weight: 600; text-align: center;
        }
        .shake { animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both; }
        @keyframes shake { 10%, 90% { transform: translate3d(-1px, 0, 0); } 20%, 80% { transform: translate3d(2px, 0, 0); } 30%, 50%, 70% { transform: translate3d(-4px, 0, 0); } 40%, 60% { transform: translate3d(4px, 0, 0); } }
      `.trim();

      const style = document.createElement("style");
      style.id = "rf-ultra-v38-css";
      style.textContent = css;
      document.head.appendChild(style);
    }

    render() {
      const basePrice = this.formatMoney(this.base);
      
      this.el.innerHTML = `
        <div class="rfW" role="region">
          <div class="rfHeader">
            <h2 class="rfH1">Jouw Gezin als Kunstwerk</h2>
            <p class="rfLead">Ontwerp een uniek, handgemaakt symbool van jouw familie. Minimalistisch design dat in elk interieur past.</p>
            <div class="rfBadges">
              <span class="rfBadge"><i>★</i> Handgemaakt</span>
              <span class="rfBadge"><i>★</i> ${this.deliveryText}</span>
              <span class="rfBadge"><i>★</i> Veilig betalen</span>
            </div>
          </div>

          <div class="rfCard" data-block="mode">
            <label class="rfLabel">1. Wie wil je vereeuwigen?</label>
            <div class="rfRow" data-group="mode">
              <button type="button" class="rfChip" data-val="Koppel">❤️ Koppel</button>
              <button type="button" class="rfChip" data-val="Single">👤 Single Parent</button>
            </div>
          </div>

          <div class="rfCard rfHide" data-block="parents">
            <label class="rfLabel">2. Samenstelling ouders</label>
            <div style="margin-bottom: 16px;">
              <div class="rfNote" style="margin-bottom:6px;">Eerste figuur (Groot)</div>
              <div class="rfRow" data-group="pop1">
                <button type="button" class="rfChip" data-val="Man">Man</button>
                <button type="button" class="rfChip" data-val="Vrouw">Vrouw</button>
              </div>
              <div class="rfColors rfHide" data-colors="pop1Color"></div>
            </div>

            <div class="rfHide" data-sub-block="pop2" style="border-top: 1px solid var(--rf-border); padding-top:16px; margin-top:16px;">
              <div class="rfNote" style="margin-bottom:6px;">Tweede figuur (Groot)</div>
              <div class="rfRow" data-group="pop2">
                <button type="button" class="rfChip" data-val="Man">Man</button>
                <button type="button" class="rfChip" data-val="Vrouw">Vrouw</button>
              </div>
              <div class="rfColors rfHide" data-colors="pop2Color"></div>
            </div>
          </div>

          <div class="rfCard rfHide" data-block="kids">
            <label class="rfLabel">3. Hoeveel kinderen?</label>
            <div class="rfRow" data-group="kids" id="rf-kids-row"></div>
            <div class="rfNote" id="rf-kids-note"></div>
            
            <div class="rfHide" data-colors="kidsColor" style="margin-top: 20px;">
              <div class="rfLabel">Kleur van de kinderen</div>
              <div class="rfColors" data-colors-target="kidsColor"></div>
              <div class="rfNote">Alle kinderen krijgen dezelfde kleur voor eenheid.</div>
            </div>
          </div>

          <div class="rfCard rfHide" data-block="pet">
            <label class="rfLabel">4. Huisdieren toevoegen? (Optioneel)</label>

            <!-- HONDEN -->
            <div style="margin-bottom: 16px;">
              <div class="rfNote" style="margin-bottom:6px; font-weight:600;">🐕 Honden</div>
              <div class="rfRow" data-group="dogCount">
                <button type="button" class="rfChip" data-val="0" data-active="true">Geen</button>
                <button type="button" class="rfChip" data-val="1">1 Hond</button>
                <button type="button" class="rfChip" data-val="2">2 Honden</button>
              </div>
            </div>

            <!-- Hond 1 opties -->
            <div class="rfHide rfPetSubBlock" id="rf-dog1-wrap">
              <div class="rfPetSubTitle">🐕 Hond 1</div>
              <div class="rfNote" style="margin-bottom:6px;">Type oren</div>
              <div class="rfRow" data-group="dog1Ears">
                <button type="button" class="rfChip" data-val="Hangoren">Hangoren</button>
                <button type="button" class="rfChip" data-val="Opstaande oren">Opstaande oren</button>
              </div>
              <div class="rfNote" style="margin-top:10px; margin-bottom:4px;">Kleur</div>
              <div class="rfColors" data-colors-target="dog1Color"></div>
            </div>

            <!-- Hond 2 opties -->
            <div class="rfHide rfPetSubBlock" id="rf-dog2-wrap">
              <div class="rfPetSubTitle">🐕 Hond 2</div>
              <div class="rfNote" style="margin-bottom:6px;">Type oren</div>
              <div class="rfRow" data-group="dog2Ears">
                <button type="button" class="rfChip" data-val="Hangoren">Hangoren</button>
                <button type="button" class="rfChip" data-val="Opstaande oren">Opstaande oren</button>
              </div>
              <div class="rfNote" style="margin-top:10px; margin-bottom:4px;">Kleur</div>
              <div class="rfColors" data-colors-target="dog2Color"></div>
            </div>

            <!-- POEZEN -->
            <div style="margin-top: 20px; padding-top: 16px; border-top: 1px solid var(--rf-border);">
              <div class="rfNote" style="margin-bottom:6px; font-weight:600;">🐈 Poezen</div>
              <div class="rfRow" data-group="catCount">
                <button type="button" class="rfChip" data-val="0" data-active="true">Geen</button>
                <button type="button" class="rfChip" data-val="1">1 Poes</button>
                <button type="button" class="rfChip" data-val="2">2 Poezen</button>
              </div>
            </div>

            <!-- Poes 1 opties -->
            <div class="rfHide rfPetSubBlock" id="rf-cat1-wrap">
              <div class="rfPetSubTitle">🐈 Poes 1</div>
              <div class="rfNote" style="margin-bottom:4px;">Kleur</div>
              <div class="rfColors" data-colors-target="cat1Color"></div>
            </div>

            <!-- Poes 2 opties -->
            <div class="rfHide rfPetSubBlock" id="rf-cat2-wrap">
              <div class="rfPetSubTitle">🐈 Poes 2</div>
              <div class="rfNote" style="margin-bottom:4px;">Kleur</div>
              <div class="rfColors" data-colors-target="cat2Color"></div>
            </div>
          </div>

          <div class="rfCard rfHide" data-block="extras">
            <label class="rfLabel">Bijzondere details (Optioneel)</label>
            
            <div class="rfHide" id="rf-twin-wrapper">
              <label style="display:flex; align-items:center; gap:10px; cursor:pointer; margin-bottom:10px;">
                <input type="checkbox" id="rf-twin-check" style="accent-color:var(--rf-gold); width:18px; height:18px;">
                <span style="font-size:14px; font-weight:600;">Is er een tweeling?</span>
              </label>
              <div class="rfHide" id="rf-twin-opt" style="padding-left:28px; margin-bottom:15px;">
                <select id="rf-twin-sel" class="rfSelect">
                  <option value="">Kies nummers...</option>
                </select>
              </div>
            </div>

            <div class="rfHide" id="rf-star-wrapper">
              <label style="display:flex; align-items:center; gap:10px; cursor:pointer;">
                <input type="checkbox" id="rf-star-check" style="accent-color:var(--rf-gold); width:18px; height:18px;">
                <span style="font-size:14px; font-weight:600;">Is er een sterrekindje? ⭐</span>
              </label>
              <div class="rfHide" id="rf-star-opt" style="padding-left:28px; margin-top:5px;">
                <select id="rf-star-sel" class="rfSelect">
                  <option value="">Kies kindje...</option>
                </select>
              </div>
            </div>
          </div>

          <div class="rfError" id="rf-main-error"></div>
          <div class="rfNote" style="text-align:center; margin-top:12px;" id="rf-summary-text">Maak je keuzes om de prijs te zien.</div>

          <div class="rfSticky">
            <div class="rfStickyInner">
              <div class="rfPriceBlock">
                <span class="rfLabelSmall">Totaalprijs</span>
                <span class="rfTotal" id="rf-total-price">${basePrice}</span>
              </div>
              <button type="button" class="rfCTA" id="rf-cta-btn" disabled>Vul set in</button>
            </div>
          </div>
        </div>
      `;

      // Render color pickers
      this.renderColors(this.el.querySelector('[data-colors="pop1Color"]'), "pop1Color");
      this.renderColors(this.el.querySelector('[data-colors="pop2Color"]'), "pop2Color");
      this.renderColors(this.el.querySelector('[data-colors-target="kidsColor"]'), "kidsColor");
      this.renderColors(this.el.querySelector('[data-colors-target="dog1Color"]'), "dog1Color");
      this.renderColors(this.el.querySelector('[data-colors-target="dog2Color"]'), "dog2Color");
      this.renderColors(this.el.querySelector('[data-colors-target="cat1Color"]'), "cat1Color");
      this.renderColors(this.el.querySelector('[data-colors-target="cat2Color"]'), "cat2Color");
    }

    renderColors(container, key) {
      if (!container) return;
      container.innerHTML = this.colors.map(c => `
        <button type="button" class="rfColorBtn" data-key="${key}" data-val="${c.label}">
          <span class="rfDot" style="background:${c.hex}"></span>
          <span class="rfColorLabel">${c.label}</span>
        </button>
      `).join("");
    }

    cache() {
      const q = s => this.el.querySelector(s);
      this.ui = {
        wrapper: q('.rfW'),
        cta: q('#rf-cta-btn'),
        total: q('#rf-total-price'),
        error: q('#rf-main-error'),
        summary: q('#rf-summary-text'),
        bMode: q('[data-block="mode"]'),
        bParents: q('[data-block="parents"]'),
        bKids: q('[data-block="kids"]'),
        bPet: q('[data-block="pet"]'),
        bExtras: q('[data-block="extras"]'),
        subPop2: q('[data-sub-block="pop2"]'),
        wTwin: q('#rf-twin-wrapper'),
        wStar: q('#rf-star-wrapper'),
        twinCheck: q('#rf-twin-check'),
        twinBox: q('#rf-twin-opt'),
        twinSel: q('#rf-twin-sel'),
        starCheck: q('#rf-star-check'),
        starBox: q('#rf-star-opt'),
        starSel: q('#rf-star-sel'),
        cPop1: q('[data-colors="pop1Color"]'),
        cPop2: q('[data-colors="pop2Color"]'),
        cKids: q('[data-colors="kidsColor"]'),
        wDog1: q('#rf-dog1-wrap'),
        wDog2: q('#rf-dog2-wrap'),
        wCat1: q('#rf-cat1-wrap'),
        wCat2: q('#rf-cat2-wrap'),
      };
      this.buildKidsGrid();
    }

    bind() {
      this.el.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        if (!btn) return;

        if (btn.classList.contains('rfChip')) {
          const groupEl = btn.closest('[data-group]');
          const group = groupEl ? groupEl.dataset.group : null;
          const val = btn.dataset.val;
          
          if (group && val !== undefined) {
            groupEl.querySelectorAll('.rfChip').forEach(b => b.dataset.active = "false");
            btn.dataset.active = "true";

            if (group === 'mode') this.setMode(val);
            if (group === 'pop1') { this.state.pop1 = val; this.ui.cPop1.classList.remove('rfHide'); }
            if (group === 'pop2') { this.state.pop2 = val; this.ui.cPop2.classList.remove('rfHide'); }
            if (group === 'kids') this.setKids(val);
            if (group === 'dogCount') this.setDogCount(parseInt(val));
            if (group === 'catCount') this.setCatCount(parseInt(val));
            if (group === 'dog1Ears') this.state.dog1Ears = val;
            if (group === 'dog2Ears') this.state.dog2Ears = val;

            this.update();
          }
        }

        if (btn.classList.contains('rfColorBtn')) {
          const key = btn.dataset.key;
          const val = btn.dataset.val;
          
          if (key && val) {
             const parent = btn.parentElement;
             parent.querySelectorAll('.rfColorBtn').forEach(b => b.dataset.active = "false");
             btn.dataset.active = "true";
             this.state[key] = val;
             this.update();
          }
        }
        
        if (btn.id === 'rf-cta-btn') this.submit();
      });

      this.ui.twinCheck.addEventListener('change', () => {
        this.state.twin = this.ui.twinCheck.checked;
        this.ui.twinBox.classList.toggle('rfHide', !this.state.twin);
        this.update();
      });
      this.ui.twinSel.addEventListener('change', () => {
        this.state.twinPair = this.ui.twinSel.value;
        this.update();
      });
      this.ui.starCheck.addEventListener('change', () => {
        this.state.star = this.ui.starCheck.checked;
        this.ui.starBox.classList.toggle('rfHide', !this.state.star);
        this.update();
      });
      this.ui.starSel.addEventListener('change', () => {
        this.state.starChild = this.ui.starSel.value;
        this.update();
      });
    }

    setMode(val) {
      this.state.mode = val;
      this.ui.bParents.classList.remove('rfHide');
      if (val === 'Single') {
        this.state.pop2 = null; 
        this.state.pop2Color = null;
        this.ui.subPop2.classList.add('rfHide');
      } else {
        this.ui.subPop2.classList.remove('rfHide');
      }
      this.buildKidsGrid(); 
    }

    setKids(val) {
      this.state.kids = val;
      const count = parseInt(val);
      if (count > 0) {
        this.ui.cKids.classList.remove('rfHide');
      } else {
        this.ui.cKids.classList.add('rfHide');
        this.state.kidsColor = null;
      }
    }

    setDogCount(count) {
      this.state.dogCount = count;
      // Reset opties die niet meer van toepassing zijn
      if (count < 2) { this.state.dog2Ears = null; this.state.dog2Color = null; }
      if (count < 1) { this.state.dog1Ears = null; this.state.dog1Color = null; }
    }

    setCatCount(count) {
      this.state.catCount = count;
      if (count < 2) { this.state.cat2Color = null; }
      if (count < 1) { this.state.cat1Color = null; }
    }

    buildKidsGrid() {
      const container = document.getElementById('rf-kids-row');
      if (!container) return;
      
      container.innerHTML = '';
      const min = this.state.mode === 'Single' ? 1 : 0;
      const max = 5;

      for (let i = min; i <= max; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rfChip';
        btn.dataset.val = i;
        btn.textContent = i === 0 ? "Geen" : i;
        if (String(this.state.kids) === String(i)) btn.dataset.active = "true";
        container.appendChild(btn);
      }
      
      const note = document.getElementById('rf-kids-note');
      if (note) {
        note.textContent = this.state.mode === 'Single' 
          ? "Bij een Single Parent set is minimaal 1 kindje nodig." 
          : "Kies geen voor alleen een liefdeskoppel.";
      }
    }

    updateExtrasDropdowns() {
      const k = parseInt(this.state.kids || 0);

      if (this.ui.wTwin) this.ui.wTwin.classList.toggle('rfHide', k < 2);
      if (this.ui.wStar) this.ui.wStar.classList.toggle('rfHide', k < 1);

      let twinHtml = '<option value="">Kies (bijv. 1/2)</option>';
      if (k >= 2) {
         for (let i = 1; i < k; i++) {
           const txt = `${i} & ${i+1}`;
           const sel = (this.state.twinPair === txt) ? 'selected' : '';
           twinHtml += `<option value="${txt}" ${sel}>Kindje ${txt}</option>`;
         }
      }
      if (this.ui.twinSel) this.ui.twinSel.innerHTML = twinHtml;

      let starHtml = '<option value="">Kies kindje...</option>';
      if (k >= 1) {
         for (let i = 1; i <= k; i++) {
           const sel = (this.state.starChild === String(i)) ? 'selected' : '';
           starHtml += `<option value="${i}" ${sel}>Kindje ${i}</option>`;
         }
      }
      if (this.ui.starSel) this.ui.starSel.innerHTML = starHtml;

      if (k < 2 && this.state.twin) { 
        this.state.twin = false; 
        if (this.ui.twinCheck) this.ui.twinCheck.checked = false; 
        if (this.ui.twinBox) this.ui.twinBox.classList.add('rfHide');
      }
      if (k < 1 && this.state.star) {
        this.state.star = false;
        if (this.ui.starCheck) this.ui.starCheck.checked = false; 
        if (this.ui.starBox) this.ui.starBox.classList.add('rfHide');
      }

      const showExtras = k > 0 && !!this.state.kidsColor;
      if (this.ui.bExtras) this.ui.bExtras.classList.toggle('rfHide', !showExtras);
    }

    update({ silent } = {}) {
      if (this.state.mode === 'Koppel' && this.state.pop1Color) {
        if (this.ui.subPop2) this.ui.subPop2.classList.remove('rfHide');
      }
      const parentsReady = (this.state.mode === 'Single' && this.state.pop1Color) || 
                           (this.state.mode === 'Koppel' && this.state.pop1Color && this.state.pop2Color);
      
      if (parentsReady) {
         if (this.ui.bKids) this.ui.bKids.classList.remove('rfHide');
      }

      // Huisdieren pas tonen nadat kids is ingevuld
      const kidsReady = parentsReady && this.state.kids !== null && 
                        (parseInt(this.state.kids) === 0 || !!this.state.kidsColor);
      if (this.ui.bPet) this.ui.bPet.classList.toggle('rfHide', !kidsReady);

      // Honden UI tonen/verbergen
      if (this.ui.wDog1) this.ui.wDog1.classList.toggle('rfHide', this.state.dogCount < 1);
      if (this.ui.wDog2) this.ui.wDog2.classList.toggle('rfHide', this.state.dogCount < 2);

      // Poezen UI tonen/verbergen
      if (this.ui.wCat1) this.ui.wCat1.classList.toggle('rfHide', this.state.catCount < 1);
      if (this.ui.wCat2) this.ui.wCat2.classList.toggle('rfHide', this.state.catCount < 2);

      this.updateExtrasDropdowns();

      const err = this.validate();
      const ready = !err;

      if (this.ui.wrapper) this.ui.wrapper.classList.toggle('ready', ready);
      if (this.ui.cta) {
        this.ui.cta.disabled = !ready;
        this.ui.cta.textContent = ready ? "In winkelwagen" : "Maak set compleet";
      }
      
      if (!silent && this.ui.error) this.ui.error.style.display = 'none';

      const k = parseInt(this.state.kids || 0);
      const petCount = this.state.dogCount + this.state.catCount;
      const totalPrice = this.base + ((k + petCount) * this.extra);
      
      if (this.ui.total) this.ui.total.textContent = this.formatMoney(totalPrice);
      
      if (this.ui.summary) {
        if (ready) {
          this.ui.summary.innerHTML = "✅ Je set is compleet en klaar om gemaakt te worden!";
          this.ui.summary.style.color = "var(--rf-green)";
          this.ui.summary.style.fontWeight = "bold";
        } else {
          this.ui.summary.innerHTML = "Kies alle opties hierboven.";
          this.ui.summary.style.color = "#78716C";
          this.ui.summary.style.fontWeight = "normal";
        }
      }

      if (this.form) this.syncShopify(k, totalPrice);
    }

    validate() {
      if (!this.state.mode) return "Kies eerst voor wie de set is.";
      if (!this.state.pop1 || !this.state.pop1Color) return "Kies de eerste ouder + kleur.";
      if (this.state.mode === 'Koppel' && (!this.state.pop2 || !this.state.pop2Color)) return "Kies de tweede ouder + kleur.";
      if (this.state.kids === null) return "Kies aantal kinderen.";
      if (parseInt(this.state.kids) > 0 && !this.state.kidsColor) return "Kies de kleur van de kinderen.";
      
      // Honden validatie
      if (this.state.dogCount >= 1) {
        if (!this.state.dog1Ears) return "Kies het type oren voor Hond 1.";
        if (!this.state.dog1Color) return "Kies een kleur voor Hond 1.";
      }
      if (this.state.dogCount >= 2) {
        if (!this.state.dog2Ears) return "Kies het type oren voor Hond 2.";
        if (!this.state.dog2Color) return "Kies een kleur voor Hond 2.";
      }

      // Poezen validatie
      if (this.state.catCount >= 1 && !this.state.cat1Color) return "Kies een kleur voor Poes 1.";
      if (this.state.catCount >= 2 && !this.state.cat2Color) return "Kies een kleur voor Poes 2.";
      
      if (this.state.twin && !this.state.twinPair) return "Selecteer welke kindjes de tweeling zijn.";
      if (this.state.star && !this.state.starChild) return "Selecteer welk kindje het sterrekindje is.";
      return null;
    }

    getPetText() {
      const parts = [];
      if (this.state.dogCount >= 1) parts.push(`Hond 1 - ${this.state.dog1Ears} (${this.state.dog1Color})`);
      if (this.state.dogCount >= 2) parts.push(`Hond 2 - ${this.state.dog2Ears} (${this.state.dog2Color})`);
      if (this.state.catCount >= 1) parts.push(`Poes 1 (${this.state.cat1Color})`);
      if (this.state.catCount >= 2) parts.push(`Poes 2 (${this.state.cat2Color})`);
      return parts.length > 0 ? parts.join(', ') : 'Geen';
    }

    submit() {
      const err = this.validate();
      if (err) {
        if (this.ui.error) {
          this.ui.error.textContent = err;
          this.ui.error.style.display = 'block';
        }
        if (this.ui.wrapper) {
          this.ui.wrapper.classList.remove('shake');
          void this.ui.wrapper.offsetWidth;
          this.ui.wrapper.classList.add('shake');
        }
        return;
      }
      
      this.ui.cta.textContent = "Toevoegen...";
      
      if (this.form) {
        this.form.submit();
      } else {
        console.log("Formulier niet gevonden, we gebruiken de AJAX fallback methode!");
        
        const k = parseInt(this.state.kids || 0);
        const petCount = this.state.dogCount + this.state.catCount;
        const totalEntities = k + petCount;
        const variantId = this.variants[totalEntities] || this.variants[k];

        if (!variantId) {
            alert("Systeemfout: Variant ID niet gevonden in de data. Neem contact op.");
            this.ui.cta.textContent = "Fout in instellingen";
            return;
        }

        const formData = {
          items: [{
            id: variantId,
            quantity: 1,
            properties: {
              "Type Set": this.state.mode,
              "Ouder 1": `${this.state.pop1} (${this.state.pop1Color})`,
              "Ouder 2": this.state.mode === 'Koppel' ? `${this.state.pop2} (${this.state.pop2Color})` : "",
              "Aantal Kinderen": k,
              "Kleur Kinderen": this.state.kidsColor || "n.v.t.",
              "Huisdieren": this.getPetText(),
              "Opties": `Tweeling: ${this.state.twin ? this.state.twinPair : 'Nee'}, Sterrekindje: ${this.state.star ? this.state.starChild : 'Nee'}`
            }
          }]
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        })
        .then(response => {
          if (!response.ok) throw new Error("Netwerk error");
          return response.json();
        })
        .then(() => {
          window.location.href = "/cart";
        })
        .catch((error) => {
          console.error('AJAX Toevoegen mislukt:', error);
          alert("Oeps! Er is iets misgegaan bij het toevoegen. Probeer de pagina te herladen.");
          this.ui.cta.textContent = "Probeer opnieuw";
          this.ui.cta.disabled = false;
        });
      }
    }

    findFormRetry() {
      let attempts = 0;
      const tick = () => {
        attempts++;
        
        const root = this.el.closest("shopify-section") || this.el.closest("main") || document;
        
        this.form = root.querySelector('form[action*="/cart/add"]') || 
                    root.querySelector('form[id*="product_form"]') ||
                    root.querySelector('product-form form') ||
                    root.querySelector('form[data-type="add-to-cart-form"]') ||
                    document.querySelector('form[action*="/cart/add"]');
        
        if (this.form) {
             console.log("RF Configurator: Formulier succesvol gevonden!");
             return;
        }
        if (attempts > 20) {
             console.warn("RF Configurator: Formulier zoeken gestopt. Wij gaan de AJAX Fallback methode gebruiken bij toevoegen.");
             return; 
        }
        setTimeout(tick, 250);
      };
      tick();
    }

    syncShopify(kidsCount, total) {
      const setProp = (k, v) => {
        let input = this.form.querySelector(`input[name="properties[${k}]"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${k}]`;
          this.form.appendChild(input);
        }
        input.value = v;
      };

      setProp("Type Set", this.state.mode);
      setProp("Ouder 1", `${this.state.pop1} (${this.state.pop1Color})`);
      if (this.state.mode === 'Koppel') {
        setProp("Ouder 2", `${this.state.pop2} (${this.state.pop2Color})`);
      } else {
        setProp("Ouder 2", "");
      }
      setProp("Aantal Kinderen", kidsCount);
      setProp("Kleur Kinderen", this.state.kidsColor || "n.v.t.");
      setProp("Huisdieren", this.getPetText());
      setProp("Opties", `Tweeling: ${this.state.twin ? this.state.twinPair : 'Nee'}, Sterrekindje: ${this.state.star ? this.state.starChild : 'Nee'}`);
      
      const petCount = this.state.dogCount + this.state.catCount;
      const totalEntities = kidsCount + petCount;
      const variantId = this.variants[totalEntities] || this.variants[kidsCount];
      
      if (variantId) {
        let idInput = this.form.querySelector('input[name="id"]');
        if (!idInput) {
           idInput = document.createElement('input');
           idInput.type = 'hidden';
           idInput.name = 'id';
           this.form.appendChild(idInput);
        }
        idInput.value = variantId;
      }
    }

    formatMoney(n) {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(n);
    }
  }

  function boot() { 
    const targets = document.querySelectorAll("[data-rf-configurator]");
    if (targets.length === 0) {
        console.warn("RF Configurator: Geen element met data-rf-configurator gevonden.");
    }
    targets.forEach(el => new RFUltraConfigurator(el)); 
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();